import seo from '../data/seoMetadata.json';

const { site, pages } = seo;

export const canonicalFor = (path) => (path === '/' ? `${site.url}/` : `${site.url}${path}`);

export const getPageMeta = (path) => {
  const page = pages[path];
  if (!page) return null;
  return { ...page, canonical: canonicalFor(path) };
};

const MANAGED = [
  'meta[name="description"]', 'link[rel="canonical"]', 'meta[name="robots"]',
  'meta[property^="og:"]', 'meta[property^="twitter:"]', 'meta[name^="twitter:"]',
  'meta[property^="article:"]', 'meta[name="keywords"]'
];

const addTag = (tag, attrs) => {
  const el = document.createElement(tag);
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  el.setAttribute('data-seo', 'true');
  document.head.appendChild(el);
};

// Replaces every managed head tag so each route ends up with exactly one set.
export const applySeo = ({ title, description, canonical, type = 'website', image = site.image, noindex, keywords, article }) => {
  document.title = title;
  document.head.querySelectorAll(MANAGED.join(',')).forEach((el) => el.remove());
  addTag('meta', { name: 'description', content: description });
  addTag('link', { rel: 'canonical', href: canonical });
  if (noindex) addTag('meta', { name: 'robots', content: 'noindex, nofollow' });
  addTag('meta', { name: 'keywords', content: keywords || site.keywords });
  const og = { type, url: canonical, site_name: site.name, title, description, image };
  Object.entries(og).forEach(([k, v]) => addTag('meta', { property: `og:${k}`, content: v }));
  const tw = { card: 'summary_large_image', url: canonical, title, description, image };
  Object.entries(tw).forEach(([k, v]) => addTag('meta', { name: `twitter:${k}`, content: v }));
  if (article) {
    if (article.published) addTag('meta', { property: 'article:published_time', content: article.published });
    addTag('meta', { property: 'article:author', content: article.author });
    (article.tags || []).forEach((t) => addTag('meta', { property: 'article:tag', content: t }));
  }
};

export const applyDefaultSeo = (path) => applySeo({
  title: site.defaultTitle,
  description: site.defaultDescription,
  canonical: canonicalFor(path)
});

export const siteMeta = site;
